import {FolderableInterface} from 'storyboard-renderer';
import {Storyboard} from 'storyboard-renderer';
import {Folder} from "storyboard-renderer";
import {TimelineTimestamp} from "storyboard-renderer";
import {Timeline} from "storyboard-renderer";

export class Template extends Storyboard implements FolderableInterface {

    read_only: boolean;

    static fromJson(json): Template {
        const storyboard = new Template(json.id, json.title, json.description, json.created_at, null);
        storyboard.folder = Folder.fromJson(json.folder);
        storyboard.aspect_ratio = json.aspect_ratio;
        storyboard.attached_audio = json.attached_audio;
        storyboard.read_only = json.read_only;

        if (json.duration) {
            storyboard.duration = new TimelineTimestamp(json.duration.as_milliseconds);
        }

        if (json.timeline) {
            storyboard.timeline = Timeline.fromJson(json.timeline);
        }

        return storyboard;
    }

}



// WEBPACK FOOTER //
// ./src/app/template/shared/template.ts